export default __webpack_public_path__ + "static/media/icon_adult.2bb035c9.svg";